export default __webpack_public_path__ + "static/media/Ok.56c05355.png";